import auth from '../api/users/auth'
function logoutOnUnauthorized (error) {
    if (error.response.status === 401) {
        auth.logout()
    } else { throw error }
}

export default logoutOnUnauthorized
